
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class PageTitleSection extends Vue {
  @Prop() title!: string | null
  @Prop({ default: null }) subtitle!: string | null
  @Prop({ default: () => [] }) folders!: any[]
}
